import { upvote as apiUpvote, downvote as apiDownvote, removeVote as apiRemoveVote, } from '@wix/ambassador-comments-v1-vote/http';
import { withDevTools } from '../../utils/with-dev-tools';
import { fromServerVote } from './vote-service-mappers';
import { assertFields } from '../../../ts-utils';
import { wrapServiceWithResult } from '../../utils/wrap-service-with-result';
export function createVotesService({ httpClient, getDevState, onError, }) {
    const service = {
        upvote: upvote(httpClient),
        downvote: downvote(httpClient),
        removeVote: removeVote(httpClient),
    };
    return wrapServiceWithResult(withDevTools(service, getDevState), {
        errorEffect: onError,
    });
}
const upvote = (httpClient) => async (payload) => {
    const { data } = await httpClient.request(apiUpvote(payload));
    assertFields(data, ['vote'], 'apiUpvote response');
    return fromServerVote(data.vote);
};
const downvote = (httpClient) => async (payload) => {
    const { data } = await httpClient.request(apiDownvote(payload));
    assertFields(data, ['vote'], 'apiDownvote response');
    return fromServerVote(data.vote);
};
const removeVote = (httpClient) => async (payload) => {
    const { data } = await httpClient.request(apiRemoveVote(payload));
    assertFields(data, ['vote'], 'apiRemoveVote response');
    return fromServerVote(data.vote);
};
//# sourceMappingURL=create-votes-service.js.map